module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1i4Pe"))).then(() => parcelRequire('d0iPb'));